const styles = theme => ({
  addGoal: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 0',
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: '#015FFB',
  },
  sectionLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    fontWeight: 500,
    color: '#002E47',
  },
  optional: {
    fontWeight: 400,
    color: '#919EAB',
  },
  courseInfo: {
    backgroundColor: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '12px',
    padding: '16px 18px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  courseInfoTitleBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  accordionContent: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    transition: 'all 0.3s ease-out',
    maxHeight: '0px',
    opacity: 0,
    '&.open': {
      maxHeight: '100%',
      opacity: 1,
    },
  },
  goalItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    marginBottom: '8px',
  },
  goalInputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
    position: 'relative',
  },
  goalInputRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
  },
  goalCharCount: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '4px',
    marginRight: '28px',
  },
  deleteButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '8px',
  },
  // Popup styles
  popupContent: {
    padding: '8px',
  },
  popupTitle: {
    color: '#637381',
  },
  suggestionList: {
    padding: 0,
    maxHeight: '200px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  popupTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px',
  },
  suggestionItem: {
    borderRadius: '8px',
    padding: '12px 8px',
    display: 'flex',
    alignItems: 'flex-start',

    gap: '8px',
    '&:hover': {
      backgroundColor: '#F4F6F8',
    },
    '&:last-child': {
      marginBottom: theme.spacing(1),
    },
  },
  suggestionText: {
    color: '#637381',
    lineHeight: 1.4,
  },
  suggestionItemIcon: {
    display: 'flex',
    width: '24px',
    height: '24px',
    minWidth: '24px',
    [theme.breakpoints.down('md')]: {
      width: '16px',
      height: '16px',
      minWidth: '16px',
      minHeight: '16px',
    },
  },
})

export default styles
